// extracted by mini-css-extract-plugin
module.exports = {"navigation":"style-module--navigation--7GSHW","items":"style-module--items--3nx2v","link":"style-module--link--2p-qO","indicator":"style-module--indicator--1UFOz"};